/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCurrencyLira = createReactComponent("outline", "currency-lira", "IconCurrencyLira", [["path", { "d": "M10 5v15a7 7 0 0 0 7 -7", "key": "svg-0" }], ["path", { "d": "M6 15l8 -4", "key": "svg-1" }], ["path", { "d": "M14 7l-8 4", "key": "svg-2" }]]);

export { IconCurrencyLira as default };
//# sourceMappingURL=IconCurrencyLira.mjs.map
